import { render, staticRenderFns } from "./MoquDirectLimitConfig.vue?vue&type=template&id=6b4c33ee&scoped=true"
import script from "./MoquDirectLimitConfig.vue?vue&type=script&lang=js"
export * from "./MoquDirectLimitConfig.vue?vue&type=script&lang=js"
import style0 from "./MoquDirectLimitConfig.vue?vue&type=style&index=0&id=6b4c33ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c33ee",
  null
  
)

export default component.exports